import { Fragment, memo, useMemo } from 'react'
import { parseURLFromTextContent } from 'src/utils/urlCheck'
import { SafeLink } from '../SafeLink'

interface CommentContentProps {
  content: string
  className?: string
}

export const CommentContent = memo(
  ({ content, className }: CommentContentProps) => {
    const segments = useMemo(() => parseURLFromTextContent(content), [content])

    return (
      <article className={className}>
        {segments.map((segment, index) => {
          if (segment.type === 'url' && segment.href) {
            return (
              <SafeLink
                key={index}
                href={segment.href}
                source="comment"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline break-all"
              >
                {segment.content}
              </SafeLink>
            )
          }
          // Regular text
          return <Fragment key={index}>{segment.content}</Fragment>
        })}
      </article>
    )
  },
)

CommentContent.displayName = 'CommentContent'
